var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"joinbox"},[_c('img',{staticClass:"joinbanner",attrs:{"src":_vm.detail.image}}),_vm._v(" "),_c('a',{staticClass:"joinbtn",attrs:{"href":_vm.detail.url,"target":"_blank"}},[_vm._v("招聘入口")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73f69566","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","audio":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vew/joinUs.vue
// module id = null
// module chunks = 